import { MenuAnimationName } from '../constants';
import type { MenuAnimationNameType, Translations } from '../Menu.types';
import type { AnimationState } from './components/MenuItem/useAnimationState';

/**
 * The viewer will duplicate the styles of the menu component onto an id with this prefix
 * used to pass CSS variables from top-level menu to MenuContent inside of HamburgerOverlay portal
 */
export const MENU_CONTENT_ID_PREFIX = 'portal-';

export const testIds = {
  menuItem: 'menu-item',
  childrenWrapper: 'children-wrapper',
  itemLabel: 'item-label',
  scrollBackwardButton: 'scroll-backward-button',
  scrollForwardButton: 'scroll-forward-button',
};

export const defaultTranslations: Translations['translations'] = {
  menuNavAriaLabel: 'Site',
  dropdownButtonAriaLabel: 'Button to toggle menu',
};

export const ANIMATION_CONFIG_MAP = {
  [MenuAnimationName.None]: {
    duration: 0,
  },
  [MenuAnimationName.Underline]: {
    duration: 400,
  },
  [MenuAnimationName.Wash]: {
    duration: 400,
  },
};

export const INITIAL_ANIMATION_STATE: AnimationState<MenuAnimationNameType> = {
  name: MenuAnimationName.None,
};

export const AnimationParts = {
  DropdownContainer: 'dropdown-container',
  DropdownIcon: 'dropdown-icon',
  Label: 'label',
  DropdownItem: 'dropdown-item',
  DropdownItemLabel: 'dropdown-item-label',
  DropdownSubItem: 'dropdown-subitem',
  DropdownSubItemLabel: 'dropdown-subitem-label',
  MenuItem: 'menu-item',
  MenuItemContent: 'menu-item-content',
} as const;
